// Angular
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
// Material
import { MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatRadioModule, MatIconModule, MatAutocompleteModule } from '@angular/material';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// NGRX
import { StoreModule } from '@ngrx/store';
// import { EffectsModule } from '@ngrx/effects';
// CRUD
import { InterceptService } from '../../../core/_base/crud/';
// Module components
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
// Auth
// import { AuthEffects, AuthGuard, authReducer, AuthService } from '../../../core/auth';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { RegisterService } from './register/services/register.service';
import { LoginService } from './login/services/login.service';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { ForgotPasswordService } from './forgot-password/services/forgot-password.service';
import { SharedModule } from '../../../shared/shared-components/shared.module';
import { MustMatchDirective } from './register/must-match.directive';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AgmCoreModule } from '@agm/core';

import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { InaugurationScreenComponent } from './inauguration-screen/inauguration-screen.component';

const routes: Routes = [
	{
		path: '',
		component: AuthComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full',
				// data: { animation: 'isLeft' }
			},
			{
				path: 'login',
				component: LoginComponent,
				data: { returnUrl: window.location.pathname }
			},
			{
				path: 'register',
				component: RegisterComponent,
				data: { animation: 'isRight' }
			},
			{
				path: 'forgot-password',
				component: ForgotPasswordComponent,
				data: { animation: 'isLeft' }
			},
			{
				path: 'portal-inauguration',
				component: InaugurationScreenComponent,
				data: { animation: 'isLeft' }
			},
		]
	}
];


@NgModule({
	imports: [
		SharedModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		RouterModule.forChild(routes),
		MatInputModule,
		MatFormFieldModule,
		MatSelectModule,
		MatAutocompleteModule,
		MatCheckboxModule,
		MatIconModule,
		MatRadioModule,
		HttpClientModule,
		InternationalPhoneNumberModule,
		RecaptchaFormsModule,
		RecaptchaModule,
		BsDropdownModule.forRoot(),
		NgxIntlTelInputModule,
		TranslateModule.forChild(),
		// StoreModule.forFeature('auth', authReducer),
		// EffectsModule.forFeature([AuthEffects]),
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyC5wzEBHV_vzzybukHvJDqp0XsglftJvUY',
			libraries: ['places']
		})
	],
	providers: [
		InterceptService,
		SharedService,
		RegisterService,
		LoginService,
		ForgotPasswordService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptService,
			multi: true
		},
	],
	// exports: [AuthComponent],
	declarations: [
		AuthComponent,
		LoginComponent,
		RegisterComponent,
		ForgotPasswordComponent,
		MustMatchDirective,
		InaugurationScreenComponent,
	]
})

export class AuthModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: AuthModule,
			providers: [
				// AuthService,
				// AuthGuard
			]
		};
	}
}
